import { useState } from "react";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import Reveal from "./Reveal";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!EMAIL_RE.test(email.trim())) {
      toast.error("Por favor, informe um e-mail válido.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email: email.trim() });
      if (data.status === "exists") {
        toast.info("Este e-mail já está cadastrado.");
      } else {
        toast.success("E-mail cadastrado com sucesso! Em breve você receberá novidades da Deco Sweet 🤎");
      }
      setEmail("");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Não foi possível cadastrar. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bg-beige py-16">
      <div className="mx-auto max-w-[1400px] px-5">
        <Reveal>
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="flex items-center gap-5 text-center md:text-left">
              <span className="hidden sm:flex h-14 w-14 rounded-full bg-choco text-gold items-center justify-center shrink-0"><Mail size={22} /></span>
              <div>
                <h3 className="font-serif text-3xl text-choco">Receba novidades e delícias exclusivas</h3>
                <p className="text-sm text-muted-foreground mt-1">Cadastre-se e fique por dentro das novidades da Deco Sweet.</p>
              </div>
            </div>
            <form className="flex w-full md:w-auto gap-3" onSubmit={submit}>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Seu melhor e-mail" data-testid="newsletter-input"
                className="flex-1 md:w-72 rounded-full bg-cream border border-choco/15 px-6 py-3.5 text-sm text-choco placeholder:text-muted-foreground focus:outline-none focus:border-gold transition-colors" />
              <button type="submit" disabled={loading} data-testid="newsletter-submit"
                className="rounded-full bg-choco text-cream px-7 py-3.5 text-xs font-semibold uppercase tracking-widest hover:bg-gold transition-colors whitespace-nowrap flex items-center gap-2 disabled:opacity-60">
                {loading && <Loader2 size={14} className="animate-spin" />} Cadastrar
              </button>
            </form>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Newsletter;
